import { CHANGE_LANG } from './types';

export function ChangeLanguage (lang) {
    return {
        type: CHANGE_LANG,
        payload: lang
    }
}